import { ResponseStatus } from 'src/app/hickory-api';

export function getSingle<T>(item: T): Single<T> {
  return {
    status: {
      resourceKey: 'string',
      isSuccess: true,
      errorCode: null,
      errorMessage: null,
      validationFailures: null
    },
    hasErrors: false,
    isValid: true,
    item: item
  };
}

export interface Single<T> {
  status?: ResponseStatus;
  hasErrors?: boolean;
  isValid?: boolean;
  item?: T;
}
